import React, { useState, useEffect } from "react";
import { auth, firestore } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./RecentActivities.css";
import Mone from "./assets/sendmoneyy.svg";
import Bills from "./assets/Billss.svg";
import Wrong from "./assets/Subtractgg.svg";
import BackRecent from "./assets/SignUpIcon/arrow-right-1.svg";

const RecentActivities = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const transactionsQuery = query(
            collection(firestore, "transactions"),
            where("userId", "==", user.uid)
          );
          const transactionsSnapshot = await getDocs(transactionsQuery);
          const transactionsList = transactionsSnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              ...data,
              date: data.date.toDate(), // Ensure the date is converted to a JS Date object
            };
          });
          setTransactions(transactionsList);
        } else {
          console.log("No authenticated user found");
        }
      } catch (error) {
        console.error("Error fetching transactions: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  const renderTransactionIcon = (type) => {
    if (type === "income") {
      return (
        <div className="transaction-icon-income">
          <img src={Mone} alt="Income Icon" style={{ width: "50%" }} />
        </div>
      );
    } else if (type === "expense") {
      return (
        <div className="transaction-icon-exp">
          <img src={Bills} alt="Expense Icon" style={{ width: "50%" }} />
        </div>
      );
    }
    return null;
  };

  if (loading) {
    return <div className="loader"></div>;
  }

  if (transactions.length === 0) {
    return (
      <div className="no-data">
        <img src={Wrong} style={{ width: 60 }} alt="No Transactions" />
        <div className="wrongText">
          <h4 style={{ fontSize: 20 }}>No Recent Transactions</h4>
          <p>No transactions have been made on this account yet.</p>
        </div>

        <button className="nodatainput" onClick={() => navigate("/dashboard")}>

          Go to Dashboard
        
        </button>
      </div>
    );
  }

  return (
    <div className="transactions-containerr">
      <div className="recentTopbar">
        <div className="recentDesign">
       
            <img className="rotatee" src={BackRecent} alt="love" />
         
          <p>Notification</p>
        </div>
      <h3>Recent Activities</h3>

      <div>Help!</div>
      </div>
      {transactions.length > 0 ? (
        <ul className="transaction-listv">
          {transactions.map((transaction, index) => (
            <li key={index} className="transaction-itemm">
              <div className="transaction-ico">
                {renderTransactionIcon(transaction.type)}
              </div>
              <div className="transaction-details">
                <div className="transaction-title">{transaction.title}</div>
                <div className="descriptionNotify">
                  <div className="transaction-description">
                    {transaction.description}
                  </div>
                  <span>{transaction.date.toLocaleDateString()}</span>
                </div>
              </div>
              <div className="transaction-titlee">
                ${parseFloat(transaction.amount).toLocaleString()}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>No recent transactions.</p>
      )}
    </div>
  );
};

export default RecentActivities;
